import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 relative" }
const _hoisted_2 = { class: "flex justify-between items-center sticky top-0" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = { class: "text-right plannedBg rounded bg-yell text-gray-600 w-min px-1.5 py-0.5 text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-2 border-b-2 select-none"
}
const _hoisted_6 = { class: "isolate flex flex-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "border-b pb-5 flex flex-col gap-3" }
const _hoisted_11 = { class: "text-sm text-gray-600" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm text-gray-600 font-normal"
}
const _hoisted_13 = { class: "border-b pb-5 flex flex-col gap-3" }
const _hoisted_14 = { class: "flex text-sm pt-4" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { class: "flex items-center justify-between relative" }
const _hoisted_17 = { class: "py-5 flex flex-col gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_LockClosedIcon = _resolveComponent("LockClosedIcon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_OculaiVideoPlayer = _resolveComponent("OculaiVideoPlayer")!
  const _component_ArrowTopRightOnSquareIcon = _resolveComponent("ArrowTopRightOnSquareIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.selectedProcess?.name ||
          _ctx.$t(`report.sections.processes.process_type_entries.${_ctx.selectedProcess?.encoded_label}`)), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.processes[0] && _ctx.formatDateDisplay(_ctx.processes[0].start_time)), 1)
    ]),
    (_ctx.processes.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.processes.length > _ctx.visibleTabCount)
            ? (_openBlock(), _createBlock(_component_ChevronLeftIcon, {
                key: 0,
                class: _normalizeClass(["w-5 h-5 cursor-pointer", [_ctx.selectedProcessIndex > 0 ? '' : 'text-gray-300']]),
                onClick: _ctx.goTabLeft
              }, null, 8, ["onClick", "class"]))
            : _createCommentVNode("", true),
          _createElementVNode("nav", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes.slice(_ctx.processTabSkip, _ctx.processTabSkip + _ctx.visibleTabCount), (process) => {
              return (_openBlock(), _createElementBlock("div", {
                key: process._id,
                class: _normalizeClass([
            _ctx.selectedProcess === process ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700',
            'group relative min-w-0 flex-1 bg-white py-2 px-3 text-center text-sm font-medium hover:bg-gray-50 focus:z-10 cursor-pointer',
          ]),
                onClick: ($event: any) => (_ctx.selectProcess(process))
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatTime(process.start_time)) + " - " + _toDisplayString(_ctx.formatTime(process.end_time)), 1),
                _createElementVNode("span", {
                  "aria-hidden": "true",
                  class: _normalizeClass([
              _ctx.selectedProcess === process ? 'bg-yellow-400' : 'bg-transparent',
              'absolute inset-x-0 h-0.5',
            ]),
                  style: {"bottom":"-2px"}
                }, null, 2)
              ], 10, _hoisted_7))
            }), 128))
          ]),
          (_ctx.processes.length > _ctx.visibleTabCount)
            ? (_openBlock(), _createBlock(_component_ChevronRightIcon, {
                key: 1,
                class: _normalizeClass(["w-5 h-5 cursor-pointer", [_ctx.selectedProcessIndex < _ctx.processes.length - 1 ? '' : 'text-gray-300']]),
                onClick: _ctx.goTabRight
              }, null, 8, ["onClick", "class"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedProcess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatTime(_ctx.selectedProcess.start_time)) + " - " + _toDisplayString(_ctx.formatTime(_ctx.selectedProcess.end_time)) + " (" + _toDisplayString(_ctx.getFormattedDuration(_ctx.selectedProcess.start_time, _ctx.selectedProcess.end_time)) + ") ", 1),
            (_ctx.selectedProcess.breaks.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("analytics.planner.processes.breaks")) + ":", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProcess.breaks, (breakItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${breakItem.start_time}-${breakItem.end_time}`
                    }, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.formatTime(breakItem.start_time)) + " - " + _toDisplayString(_ctx.formatTime(breakItem.end_time)) + " (" + _toDisplayString(_ctx.getFormattedDuration(breakItem.start_time, breakItem.end_time)) + ") ", 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("analytics.processes.working_hours")) + ":", 1),
              _createElementVNode("div", {
                class: "pl-2",
                style: _normalizeStyle({
              filter: _ctx.hideWorkingHours ? 'blur(4px)' : '',
              'user-select': _ctx.hideWorkingHours ? 'none' : 'auto',
            })
              }, _toDisplayString(`${_ctx.calculateWorkHoursSum(_ctx.selectedProcess as ShortenedProcess)} ${_ctx.$t("time.hour", {
                count: 2,
              })}`), 5),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.hideWorkingHours)
                  ? (_openBlock(), _createBlock(_component_Tooltip, {
                      key: 0,
                      content: _ctx.$t('paywall.working_hours'),
                      "wrapper-class": "overflow-hidden text-ellipsis ml-2",
                      positionHorizontal: "right",
                      positionVertical: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LockClosedIcon, { class: "h-4 w-4" })
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.open)
              ? (_openBlock(), _createBlock(_component_OculaiVideoPlayer, {
                  key: 0,
                  loading: _ctx.videoUrlLoading,
                  src: _ctx.videoUrls[_ctx.selectedProcess._id]
                }, null, 8, ["loading", "src"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              class: "flex self-end gap-1 items-center cursor-pointer text-sm",
              to: {
            name: 'DailyTimelapse',
            params: {
              customer_name: _ctx.currentCustomerName,
              site_id: _ctx.currentSiteId,
              camera_id: _ctx.selectedProcess.camera_id,
            },
            query: {
              date: _ctx.formatDate(_ctx.selectedProcess.date),
            },
          },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowTopRightOnSquareIcon, {
                  class: "w-4 h-4",
                  style: {"margin-top":"-2px"}
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("app_features.daily_timelapse")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_ctx.hasDailyReportPermission)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "flex justify-between items-center border-b py-5 cursor-pointer border-t font-semibold",
                to: {
          name: 'SingleDailyReport',
          params: {
            customer_name: _ctx.currentCustomerName,
            site_id: _ctx.currentSiteId,
            date: _ctx.formatDate(_ctx.selectedProcess.date),
          },
        },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("report.title")) + " ", 1),
                  _createVNode(_component_ArrowTopRightOnSquareIcon, {
                    class: "w-5 h-5",
                    style: {"margin-top":"-3px"}
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}